'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('HistoryCtrl', HistoryCtrl);

  HistoryCtrl.$inject = ['$state', 'historySvc', 'wellnessSvc', 'moodTrackerSvc', 'user'];

  /* @ngInject */
  function HistoryCtrl($state, historySvc, wellnessSvc, moodTrackerSvc, user) {
    var vm = this;
    vm.$onInit = activate;
    vm.scrollBusy = false;
    vm.history = [];
    vm.clientOfferingVersion = user.clientOfferingVersion;
    vm.getTracker = getTracker;
    vm.nextPage = nextPage;
    vm.trackers = [];
    vm.getAssessments = getAssessments;
    vm.currentNavItem = $state.current.name;

    ////////////////

    function activate() {
      moodTrackerSvc.getAllMoods().then(function (data) {
        vm.trackers = data;
      });

      // workaround for md-nav-bar for accessibility
      var navElement = angular.element(document.querySelector('._md-nav-bar-list'));
      navElement.attr('tabindex', '0');
    }

    function getTracker(trackerId) {
      var tracker = _.find(vm.trackers, { id: trackerId });
      return tracker;
    }

    function nextPage() {
      if (vm.scrollBusy) {
        return;
      }
      vm.scrollBusy = true;
      var dateFrom = _.isEmpty(vm.history) ? null : _.last(vm.history).date;
      historySvc.getNext(dateFrom).then(function (data) {
        // Append data regardless if History is empty, or we have not reached the last page.
        if (_.isEmpty(vm.history) || !_.isEmpty(data) && !_reachedEnd(data, vm.history)) {
          vm.history = vm.history.concat(data);
        } else {
          // End of the history chain
          vm.lastRecord = true;
        }
        vm.scrollBusy = false;
      });
    }

    // History exists. Only append if this isn't the end of the history chain.
    function _reachedEnd(thisPage, fullHistory) {
      return _.last(fullHistory).date === _.first(thisPage).date;
    }

    function getAssessments(actions) {
      return actions.filter(function (action) {
        return action.activityType.name === 'WELLNESS_ASSESSMENT' || action.activityType.name === 'QUESTIONNAIRE';
      });
    }
  }
})();